import apiWorker from '../apiWorker'

const document_folders = {
    save: (data) =>  apiWorker('post',   `/api/v1/core/document_folders/save`, data),
    find: ()     =>  apiWorker('get',   `/api/v1/core/document_folders/find`),
}

export default document_folders;